import * as url from "../url.helper";

import { post } from "../api.helper";

export const addUserDashboardWidget = data => post(url.ADD_USER_DASHBOARD_WIDGET, data);

export const getUserDashboardWidget = data => post(url.GET_USER_DASHBOARD_WIDGET, data);

export const editUserDashboardWidget = data => post(url.EDIT_USER_DASHBOARD_WIDGET, data);

export const getAdminStats = data => post(url.GET_ADMIN_STATS, data);

export const getAdminStatsPartOne = data => post(url.GET_ADMIN_STATS_PART_ONE, data);

export const getAdminStatsPartTwo = data => post(url.GET_ADMIN_STATS_PART_TWO, data);

export const getAdminDealStatus = data => post(url.GET_DEALSTATUS, data);

export const getAdminFin = data => post(url.GET_TOPFIN, data);

export const getDealCreated = data => post(url.GET_DEALCREATED, data);

export const getTopCus = data => post(url.GET_TOPCUSTOMER, data);

export const getEntityByOwners = data => post(url.GET_ENTITY_BY_OWNERS, data);

export const getEntityYears = data => post(url.GET_ENTITY_YEARS, data);

export const getEntityByPdtAndServices = data => post(url.GET_ENTITY_BY_PDT_AND_SERVICES, data);

export const getPendingTasks = data => post(url.GET_PENDING_TASKS, data);

export const getOverduetasks = data => post(url.GET_OVERDUE_TASKS, data);

export const getCusOnboarded = data => post(url.GET_CUSTOMER_ONBOARDED, data);

export const getMonthWiseInterest = data => post(url.GET_MONTHWISE_INTEREST, data);

export const getMonthWiseDeals = data => post(url.GET_MONTHWISE_DEAL_FINANCIER, data);

export const getDealStatusForFi = data => post(url.GET_DEAL_STATUS_FI, data);

export const getMonthWiseInterestForFinUser = data => post(url.GET_MONTHWISE_INTEREST_FOR_FIN_USER, data);

export const getFinAssigned = data => post(url.GET_FINASSIGNED, data);

export const getFinStats = data => post(url.GET_FINSTATS, data);

export const getDealsAssignedToCIUsers = data => post(url.GET_DEALSASSIGNEDTO_CIUSERS, data);